/* eslint-disable react/prop-types */
import {
  GridItem,
  FormControl,
  FormLabel,
  Input,
  Tooltip,
  Box,
} from "@chakra-ui/react";
import PropTypes from "prop-types";
import { useState } from "react";

const LabelInput = ({
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  type,
  inputmode,
  isRequired,
  pattern,
  isAutoCompleteOff,
  label,
  variant = "outline",
  borderRadius = "lg",
  hint,
  bg,
  borderColor,
  maxLength,
  isReadOnly,
  isDisabled,
  min,
  max,
  step,
  onKeyDown,
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [isfocused, setIsfocused] = useState(false);
  const showTooltip = !!hint;
  return (
    <GridItem pos="relative" w={"100%"}>
      <FormControl w={"100%"}>
        <FormLabel fontSize="1rem" color={"#1A202C"} htmlFor={name}>
          {label}
          {isRequired && (
            <Box as="span" color="red.500" ml={1}>
              *
            </Box>
          )}
        </FormLabel>
        <Tooltip
          mt={2}
          label={hint}
          isOpen={showTooltip && isTooltipOpen}
          // hasArrow
          placement="bottom-start"
          fontSize="sm"
          bg="gray.700"
          color="white"
          minW="100%"
        >
          <Box
            w="100%"
            onMouseEnter={() => showTooltip && setIsTooltipOpen(true)}
            onMouseLeave={() =>
              isfocused == false ? setIsTooltipOpen(false) : undefined
            }
          >
            <Input
              placeholder={placeholder}
              _placeholder={{ fontSize: "sm", color: "#90A3BF" }}
              id={name}
              name={name}
              variant={variant}
              borderRadius={borderRadius}
              type={type || "text"}
              inputMode={inputmode || "text"}
              value={value ?? ""}
              onChange={onChange}
              required={isRequired}
              isReadOnly={isReadOnly}
              isDisabled={isDisabled}
              min={min}
              max={max}
              step={step}
              autoComplete={isAutoCompleteOff ? "off" : "on"}
              bg={bg}
              borderColor={borderColor}
              _focus={{
                borderColor: borderColor || "blue.500",
                boxShadow:
                  "0 0 0 1px" + (borderColor ? " " + borderColor : " blue.500"),
              }}
              onFocus={() => {
                setIsfocused(true);
                showTooltip && setIsTooltipOpen(true);
              }}
              onBlur={(e) => {
                onBlur?.(e);
                setIsfocused(false);
                setIsTooltipOpen(false);
              }}
              onWheel={(e) => {
                if (type === "number") {
                  e.target.blur();
                }
              }}
              onKeyDown={(e) => {
                if (type === "number" && ["e", "E", "+", "-"].includes(e.key)) {
                  e.preventDefault();
                  return;
                }
                onKeyDown?.(e);
              }}
              padding={pattern}
              w={"100%"}
              h={"56px"}
              maxLength={
                maxLength ||
                (name === "phoneNumber" || name === "whatsappNumber"
                  ? "10"
                  : undefined)
              }
            />
            {/* <FormLabel
          htmlFor="segmentName"
          pos="absolute"
          top="8px"
          left="8px"
          fontSize="1rem"
          transition="all 0.2s ease-in-out"
          pointerEvents="none"
          bg="white"
          borderRadius={"lg"}
          px="1"
          zIndex={8}
        >
          <span>{placeholder}</span>
          {isRequired && <span style={{ color: "red" }}>{"*"}</span>}
        </FormLabel> */}
          </Box>
        </Tooltip>
      </FormControl>
    </GridItem>
  );
};
LabelInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  isAutoCompleteOff: PropTypes.bool,
  variant: PropTypes.string,
  borderRadius: PropTypes.string,
  hint: PropTypes.string,
  borderColor: PropTypes.string,
  maxLength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onKeyDown: PropTypes.func,
};

export default LabelInput;
